import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Tax } from '../../../models/tax';

import { NotyService } from '../../../services/common/noty.service';
import { TaxService } from '../../../services/accounting/tax.service';
import { UserService } from '../../../services/users/user.service';

declare var swal: any;

@Component({
  selector: 'app-tax-show',
  templateUrl: './tax-show.component.html',
  styleUrls: ['./tax-show.component.scss'],
})
export class TaxShowComponent implements OnInit {
  loading: boolean = true;

  tax: Tax = new Tax();

  tax_id: number;

  constructor(private route: ActivatedRoute, private notyService: NotyService, private router: Router, private taxService: TaxService, private userService: UserService) {}

  // Component life cycle methods
  ngOnInit() {
    this.userService.navbarComponent.setTaxesMenu();
    this.tax_id = Number(this.route.snapshot.params['id']);
    this.loadTax();
  }

  // Component methods
  delete() {
    swal({
      title: 'Delete Tax ?',
      text: `Delete tax - ${this.tax.name}`,
      icon: 'warning',
      className: 'swal-btn-center',
      buttons: {
        b1: {
          text: 'Cancel',
          value: 'cancel',
          className: 'btn btn-outline-secondary btn-sm',
        },
        b2: {
          text: 'Confirm',
          value: 'confirm',
          className: 'btn btn-danger btn-sm',
        },
      },
    })
      .then((value: any) => {
        if (value == 'confirm') {
          let noty: any = this.notyService.modalNotify('Deleting <i class="fas fa-spinner fa-fw fa-pulse"></i>', 'warning', false);
          this.taxService
            .delete(this.tax.id)
            .then((response_json) => {
              noty.close();
              if (response_json.success) {
                this.notyService.notify(response_json.text || 'Tax deleted', 'warning');
                this.router.navigateByUrl('/taxes');
              } else this.notyService.notify(response_json.text || 'Error deleting Tax', 'error');
            })
            .catch(() => {
              noty.close();
              this.notyService.notify('Error deleting Tax', 'error');
            });
        }
      })
      .catch((err: any) => {});
  }

  loadTax() {
    this.loading = true;
    this.taxService
      .show(this.tax_id)
      .then((tax) => {
        this.loading = false;
        this.tax = tax;
      })
      .catch(() => {
        this.loading = false;
      });
  }
}
